import React from 'react'

type Props = {
    className?: string
}

const StouxIcon = (props: Props) => {
    return (
        <svg
            className={props.className}
            width="32"
            height="32"
            viewBox="0 0 33 33"
            fill="currentColor"
            xmlns="http://www.w3.org/2000/svg"
        >
            <mask
                id="mask0_126_26"
                maskUnits="userSpaceOnUse"
                x="0"
                y="9"
                width="16"
                height="24"
            >
                <path
                    d="M15.3 32.1C6.8 31.7 0 24.7 0 16C0 13.7 0.500003 11.6 1.3 9.59998L11.7 15.6C15.2 17.6 15.8 17.1 15.4 21.6C15.2 23.5 14.5 24.3 11.3 21.6L13.2 21L6.4 15.2L4.7 23.9L7.6 22.9C13 29.7 15.3 22.5 15.3 32.1Z"
                    fill="currentColor"
                />
            </mask>
            <svg mask="url(#mask0_126_26)">
                <path
                    d="M15.7 9.69995H0V32.1H15.7V9.69995Z"
                    fill="currentColor"
                />
            </svg>
            <mask
                id="mask1_126_26"
                maskUnits="userSpaceOnUse"
                x="16"
                y="9"
                width="17"
                height="24"
            >
                <path
                    d="M30.7998 9.79993C31.5998 11.6999 32.0998 13.8999 32.0998 16.0999C32.0998 24.6999 25.3998 31.6999 16.8998 32.1999V21.9999C16.8998 17.2999 16.1998 18.1999 20.1998 15.5999C22.6998 13.9999 24.4998 13.3999 22.9998 18.6999L21.4998 17.3999L19.7998 26.1999L28.1998 23.2999L25.8998 21.2999C26.8998 18.5999 27.1998 16.5999 26.4998 13.8999C26.2998 12.7999 26.5998 12.1999 30.7998 9.79993Z"
                    fill="currentColor"
                />
            </mask>
            <svg mask="url(#mask1_126_26)">
                <path
                    d="M32.0999 9.79993H16.2V32.1999H32.0999V9.79993Z"
                    fill="currentColor"
                />
            </svg>
            <mask
                id="mask2_126_26"
                maskUnits="userSpaceOnUse"
                x="2"
                y="0"
                width="29"
                height="17"
            >
                <path
                    d="M16.1 0C22.2 0 27.4 3.3 30.2 8.3L19.8 14.3C16 16.5 16.4 17 12.4 14.4C10.1 12.9 8.6 10.9 13.6 9.1L13.2 11L21.6 8.1L14.9 2.2L14.3 5.2C5 6.7 9.1 12.4 2 8.2C4.8 3.3 10 0 16.1 0Z"
                    fill="currentColor"
                />
            </mask>
            <svg mask="url(#mask2_126_26)">
                <path d="M30.1 0H2V17H30.1V0Z" fill="currentColor" />
            </svg>
        </svg>
    )
}

export default StouxIcon
